import axios from "@/api/axiosInstance";
import { RefreshMPDashboardResponse } from "./types";

export const refreshMPDashboard =
  async (): Promise<RefreshMPDashboardResponse> => {
    const response = await axios.post<RefreshMPDashboardResponse>(
      `/api/private/stochastic/market-presence-dashboard/sync`,
    );

    return response.data;
  };
